const scrollTop = $('.scroll-top');
const scrollTopButton = $('.scroll-top__button');

$(window).on('scroll', function () {
  var scroll = $(window).scrollTop();

  if (scroll >= 400) {
    scrollTop.show();
  } else {
    scrollTop.hide();
  }
});

scrollTopButton.on('click', function () {
  $('html, body').animate(
    {
      scrollTop: 0,
    },
    0
  );
});

const page = $('html, body');

page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function () {
  page.stop();
});
